import React, { useState, useEffect, forwardRef } from "react"
import withStyles from "react-jss"
import { BuyButton, NewsletterSignup, Link } from "../components"
import colors from "../data/colors"
import { results } from "../data/results"
import { RESULT_IDS } from "../data/uniqueValues"

const AFFILIATE_COLOR = "rgb(26, 26, 26)"

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
  },
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "75vh",
    width: "100%",
    maxWidth: "1100px",
    boxSizing: "border-box",
    padding: "0 2rem",
    "@media only screen and (max-width: 500px)": {
      height: "100%",
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
  },
  title: {
    fontSize: "calc(18px + (30 - 18) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 600,
    textAlign: "center",
    padding: "2rem",
  },
  resultContainer: {
    display: "flex",
    "@media only screen and (max-width: 740px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  imgContainer: {
    width: "50%",
    "@media only screen and (max-width: 740px)": {
      width: "100%",
      maxWidth: "500px",
    },
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  result: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "4rem",
    width: "50%",
    "@media only screen and (max-width: 900px)": {
      padding: "1rem 3rem",
    },
    "@media only screen and (max-width: 740px)": {
      width: "100%",
      maxWidth: "500px",
      padding: "1.5rem 0rem 0rem 0rem",
    },
  },
  headphone: {
    fontFamily: "Apercu",
    fontWeight: 800,
    fontSize: "calc(30px + (44 - 30) * ((100vw - 300px) / (1600 - 300)))",
    margin: 0,
    lineHeight: "normal",
  },
  headphoneIntro: {
    composes: "$headphone",
    fontWeight: 400,
  },
  description: {
    fontFamily: "Apercu",
    lineHeight: 1.3,
    margin: "1rem 0 3rem 0",
    textAlign: "left",
  },
  restartText: {
    margin: "1rem 0 0.5rem 0",
    textAlign: "left",
    alignSelf: "flex-start",
  },
  restart: {
    textAlign: "left",
    fontSize: "calc(18px + (30 - 18) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 600,
    borderBottom: `2px solid ${colors.white}`,
    margin: 0,
    transition: "border 0.2s ease-in-out",
    cursor: "pointer",
    "&:hover, &:focus": {
      borderBottom: `2px solid ${colors.black}`,
    },
  },
  url: {
    textDecoration: "none",
    color: colors.black,
  },
  moreRecommendation: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    textAlign: "center",
    margin: "3rem 0 0 0",
    "@media only screen and (max-width: 740px)": {
      textAlign: "left",
    },
  },
  moreActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
    marginBottom: "5rem",
  },
  moreRecomTitle: {
    width: "100%",
    fontFamily: "Apercu",
    fontWeight: 800,
    fontSize: "calc(18px + (30 - 18) * ((100vw - 300px) / (1600 - 300)))",
    margin: 0,
    lineHeight: "normal",
    textAlign: "left",
  },
  moreRecomDesc: {
    fontFamily: "Apercu",
    lineHeight: 1.4,
    margin: "1rem 0",
    textAlign: "left",
  },
  subscriptionOffer: {
    composes: "$moreRecomDesc",
    fontStyle: "italic",
    fontSize: "calc(14px + (18 - 14) * ((100vw - 300px) / (1600 - 300)))",
    lineHeight: 1.5,
    margin: "1rem 0 0 0",
  },
  affiliateIntimation: {
    composes: "$subscriptionOffer",
    fontSize: "calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)))",
    borderTop: `1px solid rgb(229, 229, 229)`,
    paddingTop: "1rem",
    color: AFFILIATE_COLOR,
  },
  credit: {
    textTransform: "uppercase",
    fontFamily: "WiredMono, helvetica, sans-serif",
    fontStyle: "normal",
    letterSpacing: "0.045em",
    lineHeight: "1.18em",
    fontSize: "11px",
    fontWeight: "400",
    paddingTop: "0.5rem",
    color: "rgb(117, 117, 117)",
  },
}

const Result = ({ classes, id, setResetQuiz }, ref) => {
  const [data, setData] = useState({
    resultId: 0,
    result: "",
    price: "",
    retailer: "",
    url: "",
    imgURL: "",
    dek: "",
    dek2: "",
  })

  const dekData = [
    {
      resultId: 1,
      result: "Sony WH-1000XM4",
      dek: (
        <>
          These are{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="the most feature-packed noise-canceling headphones"
          />{" "}
          on the market, as well as some of the most comfortable. A
          hyper-comfortable design keeps them feeling great for up to the full
          30 hours of onboard battery life, and beamforming microphones make
          these excellent for Zoom calls.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/8x79xMVF6PgmHxtU5FGJqSPkkW8aow54tJEZsj38q9678G9WuGLrMBdjJoezGF14fhvELxNkNNf7xiwNTRsCP3EsxX3n7Mvut33dY32oYYpstGT4y5Lr6jtVKq3HuWtJdthysFkTL4DRpHXW1iSkxPjT7JTX6gqRujmRKXfb9UzZXVXi9Hp?cid=618c00090c47ce1547c65368"
            text="Bose Noise Canceling 700"
            affiliate={true}
          />
          , which have slightly better microphones but a slightly worse fit.
        </>
      ),
      caption: "Photograph: Sony",
    },
    {
      resultId: 3,
      result: "Sony WF-1000XM4",
      dek: (
        <>
          If you need{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="the best noise canceling technology"
          />{" "}
          in the most portable package, Sony’s flagship earbuds are the best
          option right now. They’re a tight fit for small ears, but memory foam
          eartips keep them secure once you get them in.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/4jjCSCMwBexmUpeGoLB5WGbAvVqSiPNvTAcuX95HitqTELtGDXNDoawW2HMDS19VWnK3baJfAse96KjhThb9oZvgUHsbatZocXf1u6XVTPJk2mCyd7P?cid=618c00090c47ce1547c65368"
            text="Apple AirPods Pro"
            affiliate={true}
          />{" "}
          and{" "}
          <Link
            url="https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHn8wyVPSxbYi1PM57iejeeFE4Xcwhx72fMqgy4zTAwEEKdk6LLks8VMWYcJZJQ5MsYkKqyoAnsdgfaVRwiYVErPZipjuzbWymoFfeuxWA4FLB?cid=618c00090c47ce1547c65368"
            text="Samsung Galaxy Buds2"
            affiliate={true}
          />{" "}
          are also great if you want excellent noise canceling from a pair of
          earbuds.
        </>
      ),
      caption: "Photograph: Sony",
    },
    {
      resultId: 4,
      result: "Apple AirPods Max",
      dek: (
        <>
          Apple’s flagship headphones remain{" "}
          <Link
            url="https://www.wired.com/review/apple-airpods-max/"
            text="the best-sounding wireless over-ears"
          />{" "}
          we’ve ever tested. They have our favorite physical controls of any
          headphones—an Apple Watch–like rotating crown—and their integration
          with Apple devices is phenomenal.
        </>
      ),
      dek2: (
        <>
          If you want{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="excellent noise canceling"
          />{" "}
          , we also like the{" "}
          <Link
            url="https://www.wired.com/review/sony-wf-1000xm4/"
            text="Sony WF-1000XM4"
          />{" "}
          and{" "}
          <Link
            url="https://www.wired.co.uk/article/bose-noise-cancelling-headphones-700-review"
            text="Bose Noise Canceling 700"
          />
          .
        </>
      ),
      caption: "Photograph: Apple",
    },
    {
      resultId: 5,
      result: "Apple AirPods Pro",
      dek: (
        <>
          Apple’s flagship earbuds have comfortable eartips, great sound,{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="and excellent noise canceling"
          />
          . You also get easy syncing with iPhones, iPads, and other Apple
          devices, as well as support for spatial audio—great for watching
          movies on the go. Sadly, they only get 4 hours of battery life (we
          hope for 6 to 9) outside of their charging cradle.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/3ft572pKqd4c9CSfrurcFRUNZoXYjB3CWQ9E8YzVhQMFuz3bryCJh4pmrixjt1zjGSqXFJrUtSRTs3A392kPUj9wPUDEGMrQRGCsSJq8u4y7Q8c8mV1n3fmy1wdGXPTznFnghCD86Un2eu1gHCxZgQrF6o7gj7pXEptzEAQyYvJmVt6gS5X7t2?cid=618c00090c47ce1547c65368"
            text="Beats Studio Buds"
            affiliate={true}
          />{" "}
          and{" "}
          <Link
            url="https://cna.st/affiliate-link/ggEqDMbDgT3Yyd4CQf1yDB7xZb9gZU8c2JT6KdpASWRrxZojEjLX7b4Yb2gAcWGpwiw6dzW272e3PSaMEpcL4mef7NyDPGAYjwytxzrym9gcanmosUwJLpKExNVa5TScL6gGWJ4xuWi?cid=618c00090c47ce1547c65368"
            text="Beats Fit Pro"
            affiliate={true}
          />{" "}
          are also great Apple-made earbuds. We do not recommend standard
          AirPods because they don't sound great and don't fit everyone's ears
          well.
        </>
      ),
      caption: "Photograph: Apple",
    },
    {
      resultId: 6,
      result: "Samsung Galaxy Buds2",
      dek: (
        <>
          These{" "}
          <Link
            url="https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHn8wyVPSxbYi1PM57iejeeFE4Xcwhx72fMqgy4zTAwEEKdk6LLks8VMWYcJZJQ5MsYkKqyoAnsdgfaVRwiYVErPZipjuzbWymoFfeuxWA4FLB?cid=618c00090c47ce1547c65368"
            text="Samsung earbuds"
            affiliate={true}
          />{" "}
          are extremely comfortable, weather-resistant, and feature Samsung’s
          excellent dual-driver array for super clear sound. They work well with
          Android phones and iPhones, but you’ll get more features on Android
          via Samsung’s companion app.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHn8wyVPSxbYi1PM57ieg9KZ9hmyEBCYrgWsmUqhfpqeok3U25xpfCQFGx8kstmt7v21KPBbZaobVYSVFcuXjJdghYL12Nr1tFyKwNdHySJ3D2?cid=618c00090c47ce1547c65368"
            text="Jabra Elite 7 Active"
            affiliate={true}
          />{" "}
          are similar, albeit slightly spendier, buds that are{" "}
          <Link
            url="https://www.wired.com/gallery/best-wireless-workout-headphones/"
            text="worth comparing to these Samsungs"
          />
          . If you are a bit harder on your earbuds, they might be a better
          choice.
        </>
      ),
      caption: "Photograph: Samsung",
    },
    {
      resultId: 7,
      result: "Sennheiser HD6XX",
      dek: (
        <>
          These open-backed headphones offer{" "}
          <Link
            url="https://www.wired.com/story/audiophile-gear-guide/"
            text="audiophile-grade sound"
          />{" "}
          for less than $200. They’re super comfy, well made, and perfect for
          home listening. Just make sure you’re in a quiet place; "open-backed"
          means the headphones will leak sound to the outside world, which also
          allows them to sound less boxed-in than many headphones.
        </>
      ),
      dek2: "",
      caption: "Photograph: Sennheiser",
    },
    {
      resultId: 8,
      result: "Monolith M570 Planar",
      dek: (
        <>
          Planar magnetic drivers have a flatter overall frequency response than
          the piston-like dynamic drivers you’re used to in most headphones.
          These Massdrop-made headphones (
          <Link
            url="https://www.wired.com/review/monoprice-monolith-m570-headphones/"
            text="9/10, WIRED Recommends"
          />
          ) sound better than any others I’ve heard under $500. Usually, quality
          planar headphones cost nearly double this price.
        </>
      ),
      dek2: "",
      caption: "Photograph: Monoprice",
    },
    {
      resultId: 9,
      result: "Shure SE11-GR",
      dek: "These affordable wired earbuds take a licking and keep on ticking. They’re comfortable and sound fantastic for their price, punching above many wireless earbuds that cost twice as much.",
      dek2: "",
      caption: "Photograph: Shure",
    },
    {
      resultId: 10,
      result: "Black Bay Tempo 30",
      dek: (
        <>
          The Back Bay Tempo 30 are{" "}
          <Link
            url="https://www.wired.com/gallery/best-headphones-under-100/"
            text="a fantastic pair of affordable earbuds"
          />{" "}
          that WIRED editor Adrienne So loves for workouts. They get 8 hours of
          battery life, have rudimentary{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="noise canceling"
          />
          , and a comfortable fit—not to mention a great price.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/4Jg9UQc1PhZqyth881NmZ42wgC19roYsgesrXvGUWeWvSo5rs4FRTpoFF1kxdFmYzUCH2gPmaztH99CQSMGQxRVz4X5oDN3yYNgtxv8oGkaJ3CprjvS7dCY6zWA4Rd2UcAVRJVerumM443R6hPkY6K1pjxqL?cid=618c00090c47ce1547c65368"
            text="1More Colorbuds"
            affiliate={true}
          />{" "}
          are a better-sounding pair, but they lack noise canceling and cost
          more.
        </>
      ),
      caption: "Photograph: Back Bay",
    },
    {
      resultId: 11,
      result: "1More Colorbuds",
      dek: (
        <>
          These are some of the most comfortable,{" "}
          <Link
            url="https://www.wired.com/gallery/best-headphones-under-100/"
            text="best-sounding earbuds we’ve tested under $100"
          />
          . They were our top pick for many months because they work great, come
          in cute colors, and pair well with both iPhones and Android devices.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/7dutxVk9viQe3CFm1DUnko8bpgpF4idaTF1RuRLqJrJXHEC43UQj7bbRixsJuxAECE1JLhydyigHy9pwEVr6Yhx8Voga9ELFotswD5srkLUqUZkg4orX3dZzrbz3kq2EV4QwhGsjpgU1YUF4C74Ze?cid=618c00090c47ce1547c65368"
            text="Back Bay Tempo 30"
            affiliate={true}
          />{" "}
          (8/10, WIRED Recommends) are also great buds, but they don’t sound
          quite as good as these Colorbuds.
        </>
      ),
      caption: "Photograph: 1More",
    },
    {
      resultId: 12,
      result: "Audio Technica M50XBT",
      dek: "These wireless over-ear headphones are perfect if you need high-quality audio or are a content creator. They’re durable, and come with a cable so you can use them even if the battery is dead—something that comes in handy on flights.",
      dek2: "",
      caption: "Photograph: Audio Technica",
    },
    {
      resultId: 13,
      result: "Ultimate Ears Fits",
      dek: (
        <>
          It can be tough to find a perfect fit if you don’t have average-sized
          and -shaped ears. The Fits (
          <Link
            url="https://www.wired.com/review/ultimate-ears-fits/"
            text="7/10, WIRED Recommends"
          />
          ) pair with an app and custom mold to your ears using UV light—kinda
          like what the dentist uses on cavities. Getting a perfect fit means
          you'll hear better bass and less outside noise. The buds will also
          stay in your ears securely.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHn8wyVPSxbYi1PM57ieg9KZ9hmyEBCYrgWsmUqhfpqeok3U25xpfCQFGx8kstmt7v21KPBbZaobVYSVFcuXjJdghYL12Nr1tFyKwNdHySJ3D2?cid=618c00090c47ce1547c65368"
            text="Jabra Elite 7 Active"
            affiliate={true}
          />{" "}
          are another great pair of earbuds for active people who can’t always
          find a good fit.
        </>
      ),
      caption: "Photograph: Ultimate Ears",
    },
    {
      resultId: 14,
      result: "Jabra Elite 45H",
      dek: "If you’re after an affordable, feature-packed pair of on-ear headphones, the Elite 45H are about the best you’ll get for the money. They’re durably made, have excellent sound, and are cheap enough that you can take them with you anywhere worry-free.",
      dek2: "",
      caption: "Photograph: Jabra",
    },
    {
      resultId: 15,
      result: "Jabra Elite 7 Active",
      dek: (
        <>
          Jabra’s ergonomic workout buds feature a proprietary coating that
          keeps them extra secure in your ears.{" "}
          <Link
            url="https://www.wired.com/gallery/best-noise-canceling-headphones/"
            text="Active noise canceling"
          />{" "}
          drowns out the world between workouts, and 8 hours of play time means
          they’ll last a full workday.
        </>
      ),
      dek2: (
        <>
          The{" "}
          <Link
            url="https://cna.st/affiliate-link/PLjJJwDSyohfc1kXTDwteGKLomnm55ApbQL3vqQdkoALFHrumjJjdsuGfRjrgVaMFR7xF9xh6FzkNiZhsN2FMbsfuyXKSayzjE3UfqnLJ?cid=618c00090c47ce1547c65368"
            text="Ultimate Ears Fits"
            affiliate={true}
          />{" "}
          are another solid (albeit expensive) option if you don’t need noise
          canceling but do want a tight fit for workouts.
        </>
      ),
      caption: "Photograph: Jabra",
    },
    {
      resultId: 16,
      result: "Grado SR60X",
      dek: (
        <>
          The Brooklyn brand’s{" "}
          <Link
            url="https://www.wired.com/gallery/best-headphones-under-100/"
            text="sub-$100 wired headphones"
          />{" "}
          are often regarded as some of the best-sounding cans you can get for
          the money, and rightfully so. They look sleek and vintage, and the
          house-made drivers offer a very clear and balanced soundstage for
          everything from Mozart to Taylor Swift.
        </>
      ),
      dek2: "",
      caption: "Photograph: Grado Labs",
    },
    {
      resultId: 17,
      result: "Beats Powerbeats",
      dek: (
        <>
          Apple’s banded in-ears are some of{" "}
          <Link
            url="https://www.wired.com/gallery/best-wireless-workout-headphones/"
            text="our favorite workout buds around"
          />
          , and they work marvelously well with iPhones. We also like how secure
          these headphones feel when on runs and other adventures; they include
          ear clips, so even if a tip gets knocked out of your ears, you won’t
          have to worry about it totally falling off your sweaty head.
        </>
      ),
      dek2: "",
      caption: "Photograph: Beats",
    },
    {
      resultId: 18,
      result: "Sennheiser IE 300",
      dek: (
        <>
          If you’re after excellent passive noise isolation, a big, bold
          soundstage, and comfortable fit, the Sennheiser IE300 are{" "}
          <Link
            url="https://www.wired.com/story/audiophile-gear-guide/"
            text="my favorite in-ears under $1,000"
          />
          . They’re simple, ergonomic, and elegant, looping comfortably around
          your ears and out of the way—perfect for podcasts, home recordings,
          and portable listening.
        </>
      ),
      dek2: (
        <>
          We’ve also recently been impressed by the similarly priced options
          from Portland, Oregon–based{" "}
          <Link
            url="https://cna.st/affiliate-link/KecyowosjiXJRznZsXrvPhHfRSimfU5mMeARLpVJAbmZBHPYNupXfmAN21aPXm7p88e3fqZMTq8?cid=618c00090c47ce1547c65368"
            text="Campfire Audio"
            affiliate={true}
          />
          , whose earbuds come in many cool colors.
        </>
      ),
      caption: "Photograph: Sennheiser",
    },
  ]

  useEffect(() => {
    if (RESULT_IDS.includes(id)) {
      const result = results.find((d) => d.resultId === id)
      const deks = dekData.find((d) => d.resultId === id)
      const userResult = {
        ...result,
        ...deks,
      }
      setData(userResult)
      if (window.parent && window.parent.dataLayer) {
        window.parent.dataLayer.push({
          event: `datavisualization-wiredHeadphoneQuiz-results-${result.result}`,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const articleClick = (uri) => {
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-wiredHeadphoneQuiz-amazonLinkClick",
        "gtm.elementUrl": uri,
      })
    }
  }

  return (
    <footer className={classes.container}>
      <div className={classes.card} ref={ref}>
        {/* <h2 className={classes.title}>
          The headphones that suits to your needs and style is ...
        </h2> */}
        <div className={classes.resultContainer}>
          <div className={classes.imgContainer}>
            <img
              className={classes.image}
              src={data.imgURL}
              alt={data.result}
            />
            <div className={classes.credit}>{data.caption}</div>
          </div>
          <div className={classes.result}>
            {/* <a
              className={classes.url}
              href={data.url}
              target="_blank"
              rel="noreferrer"> */}
            <h4 className={classes.headphoneIntro}>Check out the</h4>
            <h4 className={classes.headphone}>{data.result}</h4>
            <p className={classes.description}>{data.dek}</p>
            <BuyButton
              url={data.url}
              text={`${data.price} at ${data.retailer}`}
              onClick={() => articleClick(data.url)}
            />
            {/* </a> */}
          </div>
        </div>
        <div className={classes.moreRecommendation}>
          {data.dek2 ? (
            <>
              <h6 className={classes.moreRecomTitle}>Also check out:</h6>
              <p className={classes.moreRecomDesc}>{data.dek2}</p>
            </>
          ) : null}
        </div>

        <div className={classes.moreActions}>
          <div>
            <p className={classes.restartText}>Wanna start over?</p>
            <p
              className={classes.restart}
              tabIndex={0}
              onClick={() => setResetQuiz(true)}>
              TAKE THE QUIZ AGAIN
            </p>
          </div>

          <p className={classes.subscriptionOffer}>
            Special offer for Gear readers: Get a{" "}
            <Link
              url="https://subscribe.wired.com/subscribe/splits/wired/WIR_AFFILIATE?source=HCL_WIR_EDIT_HARDCODED_0_COMMERCE_AFFILIATE_ZZ"
              text="1-Year Subscription to WIRED for $5 ($25 off)"
            />
            . This includes unlimited access to{" "}
            <Link url="http://wired.com/" text="WIRED.com" /> and our print
            magazine (if you’d like). Subscriptions help fund the work we do
            every day.
          </p>
          <p className={classes.affiliateIntimation}>
            If you buy something using links in our stories, we may earn a
            commission. This helps support our journalism.{" "}
            <Link
              url="https://www.wired.com/2015/11/affiliate-link-policy/"
              text="Learn more"
              color={AFFILIATE_COLOR}
            />
            .
          </p>

          <NewsletterSignup />
        </div>
      </div>
    </footer>
  )
}

export default withStyles(styles)(forwardRef(Result))
